// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../icons/rectangle.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderTemplate_OrderTemplateDesc__BJ\\+\\+J * {
    padding: 0;
    margin: 0 !important
}

.OrderTemplate_OrderTemplatemain__74LLr {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    /* height: 150px; */
    /* background-color: rgb(156, 99, 99); */
    margin: 14px 0px;
    display: none;
    padding: 14px;
    border-radius: 20px;
    /* border: 1px solid red; */
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    position: relative;
    background-repeat: no-repeat;
    background-position: right;
    background-size: contain;

}

.OrderTemplate_OrderTemplateImage__iyIQO span {
    /* border: 1px solid red; */
    /* display: inline-block; */
    /* border: 1px solid red; */
    padding: 6px;
    border-radius: 50%;
    width: 35px;
    background: blue;
    display: flex;
    justify-content: center;
    color: white;
    font-weight: 500;

}



.OrderTemplate_OrderTemplateDesc__BJ\\+\\+J {
    width: 89%;
    padding-left: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding-bottom: 5px;
    /* border: 1px solid rgb(4, 245, 104); */
}

.OrderTemplate_OrderTemplateDesc__BJ\\+\\+J div:nth-child(1) p:nth-child(2) {
    font-weight: 700;
    color: black;
}

.OrderTemplate_OrderTemplateDesc__BJ\\+\\+J div:nth-child(3) p {
    width: 100%;
    font-size: 13px;
}

.OrderTemplate_OrderTemplateDesc__BJ\\+\\+J div:nth-child(3) p span:nth-child(2) {
    color: black;
    font-weight: 700;
    /* font-size: 15px; */
}



.OrderTemplate_OrderTemplateDesc__BJ\\+\\+J div:nth-child(1) p:nth-child(1) {
    color: #001AD5;
    font-weight: 500;
    font-size: 15px;

}

.OrderTemplate_OrderTemplateDesc__BJ\\+\\+J p:nth-child(1) {
    color: #4F4F4F;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;

}

.OrderTemplate_OrderTemplateedit__4Xfvd {
    position: absolute;
    right: 10px;
    top: 10px;
    /* background-color: yellow; */
    /* border-radius: 50%; */
    width: 50px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
    gap: 4px;
    /* height: 40px; */
}

.OrderTemplate_OrderTemplateedit__4Xfvd p:nth-child(1) {
    color: rgb(32, 122, 32);
    font-weight: 700;
}

.OrderTemplate_OrderTemplateedit__4Xfvd p:nth-child(2) {
    color: black;
    font-weight: 600;
}

@media screen and (max-width: 786px) {
    .OrderTemplate_OrderTemplatemain__74LLr {
        display: block;
    }

    .OrderTemplate_OrderTemplateDesc__BJ\\+\\+J p {
        display: inline-block;
    }
}

@media screen and (max-width: 375px) {

    .OrderTemplate_OrderTemplateDesc__BJ\\+\\+J {
        gap: 5px;
    }


    .OrderTemplate_OrderTemplateImage__iyIQO img {
        border-top-left-radius: 14px;
        border-bottom-left-radius: 14px;
    }

    .OrderTemplate_OrderTemplateDesc__BJ\\+\\+J p:nth-child(3) {
        padding-bottom: 0px
    }


}

@media screen and (max-width: 375px) {
    .OrderTemplate_OrderTemplatemain__74LLr {
        padding: 7px;
    }
}

@media screen and (max-width: 320px) {
    .OrderTemplate_OrderTemplateDesc__BJ\\+\\+J div:nth-child(3) p {

        font-size: 11px;
    }

    .OrderTemplate_OrderTemplateDesc__BJ\\+\\+J div:nth-child(1) {
        font-size: 14px;
    }

    .OrderTemplate_OrderTemplateDesc__BJ\\+\\+J div:nth-child(2) p {
        font-size: 14px;
    }

    .OrderTemplate_OrderTemplateedit__4Xfvd {
        gap: 22px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/OrderTemplate/OrderTemplate.module.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,wCAAwC;IACxC,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mDAA4C;IAC5C,kBAAkB;IAClB,4BAA4B;IAC5B,0BAA0B;IAC1B,wBAAwB;;AAE5B;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;;AAEpB;;;;AAIA;IACI,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;AACzB;;;;AAIA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;;AAEnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;AAErB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,8BAA8B;IAC9B,wBAAwB;IACxB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,qBAAqB;IACrB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,qBAAqB;IACzB;AACJ;;AAEA;;IAEI;QACI,QAAQ;IACZ;;;IAGA;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI;IACJ;;;AAGJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;AACJ","sourcesContent":[".OrderTemplateDesc * {\n    padding: 0;\n    margin: 0 !important\n}\n\n.OrderTemplatemain {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    /* height: 150px; */\n    /* background-color: rgb(156, 99, 99); */\n    margin: 14px 0px;\n    display: none;\n    padding: 14px;\n    border-radius: 20px;\n    /* border: 1px solid red; */\n    background: url(\"../../icons/rectangle.png\");\n    position: relative;\n    background-repeat: no-repeat;\n    background-position: right;\n    background-size: contain;\n\n}\n\n.OrderTemplateImage span {\n    /* border: 1px solid red; */\n    /* display: inline-block; */\n    /* border: 1px solid red; */\n    padding: 6px;\n    border-radius: 50%;\n    width: 35px;\n    background: blue;\n    display: flex;\n    justify-content: center;\n    color: white;\n    font-weight: 500;\n\n}\n\n\n\n.OrderTemplateDesc {\n    width: 89%;\n    padding-left: 8px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    padding-bottom: 5px;\n    /* border: 1px solid rgb(4, 245, 104); */\n}\n\n.OrderTemplateDesc div:nth-child(1) p:nth-child(2) {\n    font-weight: 700;\n    color: black;\n}\n\n.OrderTemplateDesc div:nth-child(3) p {\n    width: 100%;\n    font-size: 13px;\n}\n\n.OrderTemplateDesc div:nth-child(3) p span:nth-child(2) {\n    color: black;\n    font-weight: 700;\n    /* font-size: 15px; */\n}\n\n\n\n.OrderTemplateDesc div:nth-child(1) p:nth-child(1) {\n    color: #001AD5;\n    font-weight: 500;\n    font-size: 15px;\n\n}\n\n.OrderTemplateDesc p:nth-child(1) {\n    color: #4F4F4F;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 19px;\n\n}\n\n.OrderTemplateedit {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    /* background-color: yellow; */\n    /* border-radius: 50%; */\n    width: 50px;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-end;\n    gap: 4px;\n    /* height: 40px; */\n}\n\n.OrderTemplateedit p:nth-child(1) {\n    color: rgb(32, 122, 32);\n    font-weight: 700;\n}\n\n.OrderTemplateedit p:nth-child(2) {\n    color: black;\n    font-weight: 600;\n}\n\n@media screen and (max-width: 786px) {\n    .OrderTemplatemain {\n        display: block;\n    }\n\n    .OrderTemplateDesc p {\n        display: inline-block;\n    }\n}\n\n@media screen and (max-width: 375px) {\n\n    .OrderTemplateDesc {\n        gap: 5px;\n    }\n\n\n    .OrderTemplateImage img {\n        border-top-left-radius: 14px;\n        border-bottom-left-radius: 14px;\n    }\n\n    .OrderTemplateDesc p:nth-child(3) {\n        padding-bottom: 0px\n    }\n\n\n}\n\n@media screen and (max-width: 375px) {\n    .OrderTemplatemain {\n        padding: 7px;\n    }\n}\n\n@media screen and (max-width: 320px) {\n    .OrderTemplateDesc div:nth-child(3) p {\n\n        font-size: 11px;\n    }\n\n    .OrderTemplateDesc div:nth-child(1) {\n        font-size: 14px;\n    }\n\n    .OrderTemplateDesc div:nth-child(2) p {\n        font-size: 14px;\n    }\n\n    .OrderTemplateedit {\n        gap: 22px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"OrderTemplateDesc": `OrderTemplate_OrderTemplateDesc__BJ++J`,
	"OrderTemplatemain": `OrderTemplate_OrderTemplatemain__74LLr`,
	"OrderTemplateImage": `OrderTemplate_OrderTemplateImage__iyIQO`,
	"OrderTemplateedit": `OrderTemplate_OrderTemplateedit__4Xfvd`
};
export default ___CSS_LOADER_EXPORT___;
